import React from "react";
import "./styles.css";
import missionImg from "../../assets/img/mission.png";

function Mission() {
  return (
    <div className="mission">
      <h1>Nuestro Propósito</h1>
      <div className="mission__info">
        <p>
          Hacerte la vida más sencilla brindándote una plataforma donde podrás
          organizar, gestionar y optimizar tus procesos de ventas y soporte al
          cliente por WhatsApp.
        </p>
        <img src={missionImg} alt="Tramy graphic" />
      </div>
    </div>
  );
}

export default Mission;
